import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import CustomSelect from "../../../../../components/form/CustomSelect";
import Input from "../../../../../components/form/Input";
import { Template } from "../../../../../models";
import { generateCountOptions } from "../../../../../utils";

interface CountOption {
  label: string;
  value: number;
  icon: string;
  description: string;
}

interface RankedItemsSetupProps {
  topicFieldName: string;
  countFieldName: string;
  topicLabel: string;
  countLabel: string;
  placeholder: string;
  countOptions: CountOption[];
  defaultCount: number;
  onMount?: () => void;
}

export const topItemsCountOptions = generateCountOptions(3, 15);
export const bestItemsCountOptions = generateCountOptions(4, 11);

export default function RankedItemsSetup({
  topicFieldName,
  countFieldName,
  topicLabel,
  countLabel,
  placeholder,
  countOptions,
  defaultCount,
  onMount,
}: RankedItemsSetupProps) {
  const { values, errors, setFieldValue } =
    useFormikContext<Partial<Template>>();

  useEffect(() => {
    const currentCount = values[countFieldName as keyof Partial<Template>];
    if (!currentCount) {
      setFieldValue(countFieldName, defaultCount);
    }
    onMount?.();
  }, []);

  const topicValue =
    (values[topicFieldName as keyof Partial<Template>] as string) ?? "";
  const currentCount = values[countFieldName as keyof Partial<Template>];
  const selectedCountOption = countOptions.find(
    (option) => option.value === currentCount
  );

  return (
    <div className="space-y-4">
      <Input
        label={topicLabel}
        name={topicFieldName}
        value={topicValue}
        errorMessage={errors[topicFieldName as keyof typeof errors] as string}
        errorPosition="bottom-left"
        placeholder={placeholder}
        onChange={({ target: { value } }) => {
          setFieldValue(topicFieldName, value);
        }}
      />
      <div className="w-max">
        <CustomSelect
          label={countLabel}
          placeholder="-"
          options={countOptions}
          selected={selectedCountOption}
          setSelected={(option) => {
            setFieldValue(countFieldName, option?.value);
          }}
          maxMenuHeight={150}
          isClearable={false}
          className="max-w-24"
        />
      </div>
    </div>
  );
}
